/*
         * @ngdoc function
         * @name ePay.Model:Session_ApplePayTokenModel
         * @description
         * Model
         */
import { Session_ApplePaymentDataModel } from './Session_ApplePaymentDataModel';
import { Session_ApplePaymentMethodModel } from './Session_ApplePaymentMethodModel';

export class Session_ApplePayTokenModel {
	paymentData: Session_ApplePaymentDataModel;
	paymentMethod: Session_ApplePaymentMethodModel;
  transactionIdentifier: string | null | undefined;

	constructor(
		paymentData?: Session_ApplePaymentDataModel, 
		paymentMethod?: Session_ApplePaymentMethodModel, 
		transactionIdentifier?: string
	) {
		this.paymentData = paymentData || new Session_ApplePaymentDataModel();
		this.paymentMethod = paymentMethod || new Session_ApplePaymentMethodModel();
		this.transactionIdentifier = transactionIdentifier || null;
	}
}
